//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "event_filters",
  props: {
  },
  data() {
    return {
      teams: [],
      selected_team: null,
      teams_loaded: false,
      events: [],
      selected_event: null,
      events_loaded: false,
      weekdays: ['All','Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      selected_weekday: 'All',
      timeslots: ['All', 'Morning', 'Afternoon', 'Evening', 'Night'],
      selected_timeslot: 'All',
      hide_unavailable: true,
      priority_shifts: false,
      load_counter: 0,
      page_limit: 15

    }
  },
  created() {
    this.get_teams();
    this.get_events();
  },
  methods: {
    get_teams: function () {
      let me = this;
      me.load_counter++;
      frappe.call({
        method: 'event_management.www.event-shifts.index.get_teams',
        args: {
          'limit_start': this.teams.length,
          'limit_page_length': this.page_limit
        },
        callback: function (r) {
          let teams = r.message;
          if (teams) {
            me.teams = me.teams.concat(teams);
          }
          if (!teams || teams.length < me.page_limit) {
            me.teams_loaded = true;x
          }
        },
        always: function () {
          me.load_counter--;
        },
        // freeze the screen until the request is completed
        freeze: true,
        freeze_message: (__('Please wait') + '...')
      });
    },
    get_events: function () {
      let me = this;
      me.load_counter++;
      frappe.call({
        method: 'event_management.www.event-shifts.index.get_events',
        args: {
          'limit_start': this.events.length,
          'limit_page_length': me.page_limit
        },
        callback: function (r) {
          let events = r.message;
          if (events) {
            me.events = me.events.concat(events);
          }
          if (!events || events.length < me.page_limit) {
            me.events_loaded = true;
          }
        },
        always: function () {
          me.load_counter--;
        },
        // freeze the screen until the request is completed
        freeze: true,
        freeze_message: (__('Please wait') + '...')
      });
    },
    get_team_token: function (team) {
      if (team.name.length > 10 && team.acronym != '' && team.acronym!= null) {
        return team.acronym;
      }
      return team.name;
    },
    update_event: function(selection) {
      this.$parent.selected_event = this.selected_event = selection;
      this.$parent.reload_shifts();
    },
    clear_event_selection: function() {
      this.$parent.selected_event = this.selected_event = null;
      this.$parent.reload_shifts();
    },
    update_team: function(selection) {
      this.$parent.selected_team = this.selected_team = selection;
      this.$parent.reload_shifts();
    },
    clear_team_selection: function() {
      this.$parent.selected_team = this.selected_team = null;
      this.$parent.reload_shifts();
    },
    update_weekday: function(selection) {
      this.$parent.selected_weekday = this.selected_weekday = selection;
      this.$parent.reload_shifts();
    },
    clear_weekday_selection: function() {
      this.$parent.selected_weekday = this.selected_weekday = 'All';
      this.$parent.reload_shifts();
    },
    update_timeslot: function(selection) {
      this.$parent.selected_timeslot = this.selected_timeslot = selection;
      this.$parent.reload_shifts();
    },
    clear_timeslot_selection: function() {
      this.$parent.selected_timeslot = this.selected_timeslot = 'All';
      this.$parent.reload_shifts();
    },
    toggle_hide_unavailable: function() {
      this.$parent.hide_unavailable = this.hide_unavailable
      this.$parent.reload_shifts();
    },
    toggle_priority_shifts: function() {
      this.$parent.priority_shifts = this.priority_shifts
      this.$parent.reload_shifts();
    },
    toggle_filter: function() {
      $('#filter_sidebar').toggleClass('d-none');
    }
  },
}
